<template>
  <div>
    <Row class="operation">
      <Button @click="addRoot" icon="md-add">添加一级节点</Button>
      <Button @click="delAll" icon="md-trash">批量删除</Button>
      <Button @click="loadData" icon="md-refresh">刷新</Button>
    </Row>
    <Alert show-icon>
      已选择
      <span class="select-count">{{selectCount}}</span> 项
      这里还可以做一些数据统计显示
    </Alert>
    <tree-table
            ref="treeTable"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :border="true"
            :show-index="true"
            :is-fold="true"
            :expand-type="false"
            primary-key="id"
            @checkbox-click="changeSelect"
    >
      <template slot="action" slot-scope="scope">
        <Button type="primary" @click="add(scope.row)" size="small" icon="md-add" style="margin-right:5px">添加子节点</Button>
        <Button size="small" @click="edit(scope.row)" icon="ios-create-outline" style="margin-right:5px">编辑</Button>
        <Button type="error" @click="remove(scope.row)" size="small" icon="md-trash">删除</Button>
      </template>
    </tree-table>

    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <div v-if="showParent">
          <FormItem label="上级节点：">{{showParentTitle}}</FormItem>
        </div>
        <FormItem label="编号" prop="id" style="display: none">
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <FormItem label="父级编号" prop="parentId" style="display: none">
          <Input v-model="form.parentId" style="width:100%"/>
        </FormItem>
        <FormItem label="区域名称" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="英文/拼音" prop="enName" >
          <Input v-model="form.enName" style="width:100%"/>
        </FormItem>
        <FormItem label="区域编码" prop="code" >
          <Input v-model="form.code" style="width:100%"/>
        </FormItem>
        <Form-item label="区域类型" prop="type">
          <Select v-model="form.type">
            <Option value="1">国家</Option>
            <Option value="2">省份、直辖市</Option>
            <Option value="3">地市</Option>
            <Option value="4">区县</Option>
          </Select>
        </Form-item>
        <FormItem label="排序" prop="sort" >
          <Input v-model="form.sort" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <textarea v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="submitAdd">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import TreeTable from "@/views/my-components/tree-table/Table/Table";
  export default {
    name: "ConfigArea",
    components: {
      TreeTable
    },
    data() {
      return {
        loading: false,
        loadingEdit: false, // 编辑上级树加载状态
        modalVisible: false, // 添加显示
        selectList: [], // 多选数据
        selectCount: 0, // 多选计数
        showParent: false, // 显示上级标识
        showParentTitle:"",
        modalTitle: "", // 添加标题
        editTitle: "", // 编辑节点名称
        submitLoading: false,
        columns: [
          {
            title: "名称",
            key: "name",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "英文/拼音",
            key: "enName",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "区域编码",
            key: "code",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "区域类型",
            key: "typeName",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "备注信息",
            key: "remarks",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "排序",
            key: "sort",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            headerAlign: "center",
            width: "300px",
            type: "template",
            template: "action",
          }
        ],
        tableData: [],
        form: {
          // 编辑对象初始化数据
          id: "",
          parentId: "",
          parentIds: "",
          name: "",
          enName: "",
          sort: "",
          code: "",
          type: "",
          remarks: "",
        },
        formValidate: {
          // 表单验证规则
        }
      };
    },
    methods: {
      init() {
        this.loadData();
      },
      loadData() {
        // 异步加载树子节点数据
        this.getRequest("/configArea/getAll").then(res => {
          if (res.success){
            res.result.forEach(function (e) {
              if (e.isParent) {
                e.loading = false;
                e.children = [];
              }
            });
            this.tableData = res.result;
          }
        });
      },
      changeSelect(row, rowIndex, $event) {
        let isAdd = true;
        for (let i = 0;i<this.selectList.length;i++){
          let obj = this.selectList[i];
          if (obj == row.id){
            isAdd = false;
            this.selectList.splice(i,1);
          }
        }
        if(isAdd){
          this.selectList.push(row.id);
        }
        this.selectCount = this.$refs.treeTable.getCheckedProp().length;
      },
      submitAdd() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.postRequest("/configArea/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
            if (res.success) {
              this.$Message.success("添加成功");
              this.init();
              this.modalVisible = false;
            }
          });
          }
        });
      },
      edit(v){
        this.modalTitle = "修改";
        this.showParent = false;
        this.form = {
          id: v.id,
          parentId: v.parentId,
          parentIds: v.parentIds,
          name: v.name,
          enName: v.enName,
          sort: v.sort,
          code: v.code,
          type: v.type,
          remarks: v.remarks,
        };
        this.modalVisible = true;
      },
      add(v) {
        this.modalTitle = "添加子节点";
        this.showParent = true;
        this.showParentTitle = v.name;
        this.form = {
          id: "",
          parentId: v.id,
          parentIds: v.parentIds + "," + v.id,
          name: "",
          enName: "",
          sort: "",
          code: "",
          type: "",
          remarks: "",
        };
        this.modalVisible = true;
      },
      addRoot() {
        this.modalTitle = "添加一级节点";
        this.showParent = false;
        this.form = {
          id: "",
          parentId: 0,
          parentIds: "0,",
          name: "",
          enName: "",
          sort: "",
          code: "",
          type: "",
          remarks: "",
        };
        this.modalVisible = true;
      },
      remove(v) {
        this.$Modal.confirm({
          title: "确认删除",
          // 记得确认修改此处
          content: "您确认要删除 " + v.name + " ?",
          loading: true,
          onOk: () => {
            // 删除
            this.deleteRequest("/configArea/delByIds/" + v.id).then(res => {
              this.$Modal.remove();
              if (res.success) {
                this.$Message.success("操作成功");
                this.selectList = [];
                this.selectCount = 0;
                this.loadData();
              }
            });
          }
        });
      },
      delAll() {
        if (this.selectCount <= 0) {
          this.$Message.warning("您还未勾选要删除的数据");
          return;
        }
        this.$Modal.confirm({
          title: "确认删除",
          content: "您确认要删除所选的 " + this.selectCount + " 条数据及其下级所有数据?",
          onOk: () => {
            let ids = "";
            this.selectList.forEach(function(e) {
              ids += e + ",";
            });
            ids = ids.substring(0, ids.length - 1);
            this.deleteRequest("/configArea/delByIds/" + ids).then(res => {
                if (res.success) {
                  this.$Message.success("删除成功");
                  this.selectList = [];
                  this.selectCount = 0;
                  this.loadData();
                }
            });
          }
        });
      }
    },
    mounted() {
      this.init();
    }
  };
</script>
<style lang="less">
  .article {
    font-size: 16px;
    font-weight: 400;
    margin: 12px 0;
  }
  .href-text {
    font-size: 12px;
  }
  .operation {
    margin-bottom: 2vh;
  }
  .select-count {
    font-weight: 600;
    color: #40a9ff;
  }
</style>
